export enum Packages {
  installPackage = 'installPackage',
  activationPackage = 'activationPackage',
  postActivationPackage = 'postActivationPackage',
  loopFieldPackage = 'loopFieldPackage',
}
